import { call, fork, put, takeEvery } from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { flashes, FLASH } from 'client/features/flashes/actions'

export function* flash(action) {
    if (__SERVER) return
    const { content } = action
    content.date = new Date()
    yield put(flashes.add(content))
    yield call(delay, 3000)
    yield put(flashes.hide(content))
}

function* flashesSaga() {
    yield takeEvery(FLASH, flash)
}

/*Export watchers sagas*/
const sagas = [
    fork(flashesSaga)
]

export default sagas


// WEBPACK FOOTER //
// ./src/client/features/flashes/sagas.js